module.exports = __webpack_public_path__ + "static/src/content/images/processed/600/thurston_cover.a3a02a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/600/thurston_cover.jpg
// module id = GVF7
// module chunks = 1